import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import { type ControlProps, ControlType } from '../../../../Form';
import PropertyNameComponent from './PropertyNameComponent';
import type { CuriosityParams } from '../../../../../Curiosity';
import type { Localization } from '../../../../../common/Localization';
import FilterContainer from '../../FilterContainer';
import type { CommonProps } from '../CommonProps';

type GetPropertyNameField = {
  searchParams: SearchParams;
  curiosityParams: CuriosityParams;
  localization: Localization;
  commonProps: CommonProps;
  t: TranslationFunction;
};

type PropertyNameControlProps = ControlProps & {
  curiosityParams: CuriosityParams;
  localization: Localization;
  searchParams: SearchParams;
};

const getPropertyNameField = ({
  searchParams,
  curiosityParams,
  localization,
  t,
  commonProps,
}: GetPropertyNameField) => ({
  control: ControlType.CONTAINER,
  name: FilterContainer.PropertyNameContainer,
  top: { text: t('vacation.oss.filters.property.title') },
  controls: [
    {
      control: ControlType.EXTERNAL,
      component: PropertyNameComponent,
      name: URLParameters.ACCOMODATION_NAME,
      value: searchParams[URLParameters.ACCOMODATION_NAME],
      curiosityParams,
      localization,
      searchParams,
      commonProps,
    } as PropertyNameControlProps,
  ],
});

export default getPropertyNameField;
